import { utilizationColor } from "./ExperimentalChart";

const TICKS = [0, 25, 50, 75, 100];

/**
 * Horizontal gradient bar showing how line/dot color maps to HG utilization %.
 */
export default function UtilizationLegend() {
  const gradient = `linear-gradient(to right, ${TICKS.map(
    (t) => `${utilizationColor(t)} ${t}%`
  ).join(", ")})`;

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <p className="text-sm font-semibold text-foreground mb-3">
        Hourglass Utilization
      </p>
      <div className="h-3 rounded-full" style={{ background: gradient }} />
      <div className="flex justify-between mt-1.5 text-xs text-muted-foreground">
        {TICKS.map((t) => (
          <span key={t}>{t}%</span>
        ))}
      </div>
    </div>
  );
}
